import React, { useEffect, useRef } from 'react';

// Spec §6.2 step 3 — calls POST /push-automations/{id}/preview and shows first 100 rows.
// Wizard cannot proceed without a successful preview.
const StepPreview = ({ previewRows, previewError, previewLoading, onRunPreview }) => {
  const triedRef = useRef(false);

  // Auto-run preview on first mount of this step so the user sees data immediately.
  useEffect(() => {
    if (triedRef.current) return;
    triedRef.current = true;
    onRunPreview().catch(() => {});
  }, [onRunPreview]);

  const columns = Array.isArray(previewRows) && previewRows.length > 0 ? Object.keys(previewRows[0]) : [];

  return (
    <div className="push-step-content">
      <h3 className="push-step-title">Step 3 — Preview</h3>
      <p className="push-step-help">Running this query against your data. You can advance once a preview returns successfully.</p>
      <div className="push-preview-actions">
        <button
          className="push-secondary-button"
          onClick={() => onRunPreview().catch(() => {})}
          disabled={previewLoading}
          data-testid="push-preview-run"
        >
          {previewLoading ? 'Running...' : 'Re-run preview'}
        </button>
      </div>

      {previewError && (
        <div className="push-step-error" role="alert" data-testid="push-preview-error">
          Preview failed: {previewError}
        </div>
      )}

      {Array.isArray(previewRows) && previewRows.length > 0 && (
        <div className="push-preview-table-wrap" data-testid="push-preview-table">
          <table className="push-preview-table">
            <thead>
              <tr>{columns.map((c) => (<th key={c}>{c}</th>))}</tr>
            </thead>
            <tbody>
              {previewRows.slice(0, 100).map((row, idx) => (
                <tr key={idx}>
                  {columns.map((c) => (<td key={c}>{row[c] == null ? '' : String(row[c])}</td>))}
                </tr>
              ))}
            </tbody>
          </table>
          <p className="push-preview-footer">Showing {Math.min(previewRows.length, 100)} of {previewRows.length} row(s).</p>
        </div>
      )}

      {Array.isArray(previewRows) && previewRows.length === 0 && !previewError && (
        <p className="push-step-empty">Preview returned 0 rows. Adjust the prompt or schema before continuing.</p>
      )}
    </div>
  );
};

export default StepPreview;
